module.exports = __webpack_public_path__ + "static/media/levels_3_4.c1822fbe.svg";